import React from 'react';
import './Featured.css';
import featuredData from '../data/featured.json';
import { useContent } from '../contexts/ContentContext';

const Featured = () => {
  const { getSection } = useContent();
  const data = getSection<typeof featuredData>('featured', featuredData);
  const { featuredBanners } = data;

  return (
    <section id="featured" className="featured-section">
      <div className="featured-container">
        <div className="section-header">
          <h2 className="section-title">Featured Highlights</h2>
          <p className="section-subtitle">
            Discover the exciting opportunities and events at ASIMO Technical Club
          </p>
        </div>

        <div className="banners-container">
          {featuredBanners
            .sort((a, b) => a.order - b.order)
            .map((banner, index) => (
            <div key={banner.id} className={`banner-stack stack-${index + 1}`}>
              <div className="stack-cards">
                {/* Background cards for stack effect */}
                <div className="stack-card stack-card-3"></div>
                <div className="stack-card stack-card-2"></div>
                
                {/* Main card with content */}
                <div 
                  className="stack-card stack-card-1 main-card"
                  style={{ '--banner-gradient': banner.gradient } as React.CSSProperties}
                >
                  <div className="banner-image">
                    <img 
                      src={banner.image} 
                      alt={banner.title}
                      className="featured-image"
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                      }}
                    />
                  </div>
                  
                  <div className="banner-content">
                    <div className="banner-header">
                      <h3 className="banner-title">{banner.title}</h3>
                      <p className="banner-subtitle">{banner.subtitle}</p>
                    </div>
                    
                    <p className="banner-description">{banner.description}</p>
                    
                    <div className="banner-actions">
                      <a 
                        href={banner.buttonLink} 
                        className="btn-featured"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ '--card-gradient': banner.gradient } as React.CSSProperties}
                      >
                        <span className="btn-text">{banner.buttonText}</span>
                        <div className="waterfill-effect"></div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featured;